import React, { useEffect } from 'react'

import { useSIMTableActions } from 'redux/actions/DataPlatform/tables/v4'
import { useSourceSchemaActions } from 'redux/actions/DataPlatform/SourceSchemasV2'

import Box from 'components_new/atoms/Box'

import SimTableHeader from 'components_new/organisms/sim/TableHeader'
import Transformation from 'components_new/organisms/sim/Transformation'

import PageLayout from 'components_new/templates/PageLayout'

import { useParams } from 'utils/hooks'
import { useShouldFetchSourceSchema, useSimTable } from 'redux/hooks/SimTables'

function SimTable() {
  const { tryGetSourceSchemas } = useSourceSchemaActions()
  const { tryGetOneSIMTable } = useSIMTableActions()

  const { tableId } = useParams<{ tableId: string }>()
  const shouldFetchSourceSchemas = useShouldFetchSourceSchema()
  const table = useSimTable()

  const ontologyHref =
    table?.data_product_type === 'CUSTOM_ONTOLOGY'
      ? '/data-platform/ontology/custom'
      : '/data-platform/ontology/standard'

  // fetch source schema
  useEffect(() => {
    if (shouldFetchSourceSchemas) {
      tryGetSourceSchemas()
    }
  }, [shouldFetchSourceSchemas])

  // fetch table
  useEffect(() => {
    tryGetOneSIMTable(tableId)
  }, [tableId])

  return (
    <PageLayout
      content={{ disablePadding: true, fullWidth: true }}
      topbar={{
        breadcrumbs: [
          { title: 'Admin' },
          {
            title: 'Informationsmodell',
            href: ontologyHref
          },
          ...(table ? [{ title: table.name }] : [])
        ]
      }}
      variant="static"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <SimTableHeader />
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <Transformation />
        </Box>
      </Box>
    </PageLayout>
  )
}

export default SimTable
